import { KeycloakTokenParsed } from 'keycloak-js'

import { TemplateListDto } from '@/endpoints/models'

import { ConnectionState } from './types'

export const createTokenUpdateMessage = (token?: string) => ({
	metadata: { token },
	type: 'embedding' as const,
	command: 'updateToken',
	name: 'user',
	output: '',
})
export const createUserEnvironment = (
	tokenParsed: KeycloakTokenParsed | undefined,
) => ({
	USER_ID: tokenParsed?.sub ?? '',
	USER_EMAIL: tokenParsed?.email ?? '',
	USER_NAME: tokenParsed?.name ?? '',
})
export const INITIAL_CONNECTION_STATE: ConnectionState = {
	isConnected: true,
	isReconnecting: false,
	lastToken: undefined,
}

export const SUPPORTED_STRUCTURE_TYPES = [
	TemplateListDto.StructureTypeEnum.MAPPING_DEFAULT,
	TemplateListDto.StructureTypeEnum.MAPPING,
	TemplateListDto.StructureTypeEnum.VIEW,
	TemplateListDto.StructureTypeEnum.TABLE,
] as const
